import * as React from "react"
import { SVGProps } from "react"

export const BecuLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" id="Layer_1" x={0} y={0} viewBox="0 0 113 35" {...props}>
    <style>{".st1{fill:#fff}"}</style>
    <title>mob-becu-logo</title>
    <path
      d="M0 0v35h101c6.6 0 12-5.4 12-12V0H0z"
      style={{
        fill: "#d2282e",
      }}
    />
    <path
      d="M26 21c.2-1.9-1.1-3.6-3-4 1.6-.4 2.4-1.6 2.4-3.8S23.9 9 20.5 9H11v17h10c2.7.1 4.9-2 5-4.7V21zm-10.7-8.2h4.2c.7-.1 1.3.4 1.4 1.1v.2c0 .8-.6 1.3-1.5 1.3h-4.2v-2.6zm0 9.3v-2.9h4.3c1.1 0 1.8.5 1.8 1.4s-.6 1.5-1.7 1.5h-4.4zM50 22h-8.1v-2.8h7.9v-3.8h-7.9L42 13h8V9H38v17h12zM95 26c5.4 0 8-2.9 8-7.1V9h-4.4v9.8c0 2-1.6 3.6-3.6 3.6s-3.6-1.6-3.6-3.6V9H87v10c0 4 2.6 7 8 7zM55 6h2v23h-2zM81 6h2v23h-2z"
      className="st1"
    />
    <path d="M0 0v35h101c6.6 0 12-5.4 12-12V0H0zm110 23c0 5-4 9-9 9H3V3h107v20z" className="st1" />
    <path
      d="M26 21c.2-1.9-1.1-3.6-3-4 1.6-.4 2.4-1.6 2.4-3.8S23.9 9 20.5 9H11v17h10c2.7.1 4.9-2 5-4.7V21zm-10.7-8.2h4.2c.7-.1 1.3.4 1.4 1.1v.2c0 .8-.6 1.3-1.5 1.3h-4.2v-2.6zm0 9.3v-2.9h4.3c1.1 0 1.8.5 1.8 1.4s-.6 1.5-1.7 1.5h-4.4zM50 22h-8.1v-2.8h7.9v-3.8h-7.9L42 13h8V9H38v17h12zM69.9 26c3.1.1 5.9-1.6 7.2-4.4l-3.6-1.7c-.6 1.4-2 2.3-3.5 2.4-2.5 0-4.6-2-4.6-4.5v-.3c-.1-2.5 1.8-4.6 4.3-4.8h.3c1.5.1 2.9 1 3.5 2.4l3.6-1.7C75.8 10.6 73 8.9 69.9 9c-5 0-8.9 3.4-8.9 8.5s3.8 8.5 8.9 8.5zM95 26c5.4 0 8-2.9 8-7.1V9h-4.4v9.8c0 2-1.6 3.6-3.6 3.6s-3.6-1.6-3.6-3.6V9H87v10c0 4 2.6 7 8 7zM55 6h2v23h-2zM81 6h2v23h-2zM31 6h2v23h-2z"
      className="st1"
    />
  </svg>
)
